export enum TTProtectionState {
  Active = 0,
  Updated = 1,
  Expired = 2,
}

export enum TTProtectionStringValue {
  Active = "Active",
  Updated = "Updated",
  Expired = "Expired",
}

export const ttProtectionStateAsString = new Map([
  [TTProtectionState.Active, TTProtectionStringValue.Active],
  [TTProtectionState.Updated, TTProtectionStringValue.Updated],
  [TTProtectionState.Expired, TTProtectionStringValue.Expired],
]);
